import React from "react";
import Modal from "../../styles/Modals";
import styled from "styled-components";
import Color from "../../assets/Colors";
import {ResetButton} from "../../styles/Button";
import useQuery from "../../hooks/useQuery";
import ReactPlayer from "react-player";
import {LoadComponet} from "../../components/loaders/Loader";
import {ReactComponent as CloseIcon} from "../../assets/icons/close.svg";

// import {useHistory} from "react-router-dom";

export default function VideoModal({videoUrl, initiator}) {
   let query = useQuery();
   const isOpen = query.get(initiator) === "true" ? true : false;

   if (!isOpen) return null;
   return (
      <Modal type="video">
         {videoUrl ? (
            <ReactPlayer
               url={"http://domecqapi.trebolbit.com/" + videoUrl}
               className="react-player"
               playing
               width="100%"
               height="auto"
               controls={true}
               style={{outline: "none"}}
            />
         ) : (
            <LoadComponet isVisible={true} />
         )}
      </Modal>
   );
}

const VideoContent = styled.div`
   position: relative;
   padding: 0;
   width: 70%;
   margin: 0 auto;
   margin-top: 10%;

   @media screen and (max-width: 1600px) {
      margin-top: 5%;
      width: 60%;
   }

   @media screen and (max-width: 500px) {
      width: 95%;
   }

   & ${ResetButton} {
      position: absolute;
      top: 0;
      right: 0;
      width: 2em;
      height: 2em;
      border-radius: 50%;
      margin: 0.5em;

      &:hover {
         background: rgba(250, 250, 250, 0.3);
      }
   }
`;
